import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import {
  Circle as BulletActive,
  ExpandMoreRounded as ExpandIcon,
  SecurityOutlined as ConfidentialIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

const SidebarConfidentialDropdown = ({
  activeDropdown,
  user,
  transactions,
  cheque,
  shouldDisplayDotNotification,
  isTransactionsLoading,
  isChequeLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/confidential/gi));
  return (
    <Accordion elevation={0} square disableGutters>
      <AccordionSummary
        className={
          isActiveDropdown
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root  ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <ConfidentialIcon />
        <Typography variant="sidebar">Confidential</Typography>

        {(!isTransactionsLoading || !isChequeLoading) &&
        (shouldDisplayDotNotification(transactions, "Creation of Confidential Request") ||
          shouldDisplayDotNotification(transactions, "Tagging of Confidential Document") ||
          shouldDisplayDotNotification(transactions, "Transmittal of Confidential Document") ||
          shouldDisplayDotNotification(cheque, "Releasing of Confidential Cheque") ||
          shouldDisplayDotNotification(transactions, "Filing of Confidential Voucher")) ? (
          <BulletActive className="FstoSidebarActiveNotif-root" />
        ) : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {user.permissions.includes(2) && (
          <Box marginBottom={1}>
            <Typography variant="sidebar" marginLeft="10px" fontWeight={500} fontSize="12px">
              Requesting
            </Typography>

            <RouterLink className="FstoSidebarLink-root" to="/confidential/request">
              Creation Of Request
            </RouterLink>

            <RouterLink
              className="FstoSidebarLink-root"
              to="/confidential/request/returned-requests"
            >
              Returned Requests
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Creation of Confidential Request"
                  value="return"
                />
              )}
            </RouterLink>
          </Box>
        )}

        {user.permissions.includes(15) && (
          <Box marginBottom={1}>
            <Typography variant="sidebar" marginLeft="10px" fontWeight={500} fontSize="12px">
              Tagging
            </Typography>

            <RouterLink className="FstoSidebarLink-root" to="/confidential/tagging">
              Tagging Of Documents
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Tagging of Confidential Document"
                  value="pending"
                />
              )}
            </RouterLink>

            <RouterLink
              className="FstoSidebarLink-root"
              to="/confidential/tagging/returned-documents"
            >
              Returned/Held Documents
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Tagging of Confidential Document"
                  value="return"
                />
              )}
            </RouterLink>
          </Box>
        )}

        {user.permissions.includes(28) && (
          <Box marginBottom={1}>
            <Typography variant="sidebar" marginLeft="10px" fontWeight={500} fontSize="12px">
              Vouchering
            </Typography>

            <RouterLink className="FstoSidebarLink-root" to="/confidential/voucher/vouchering">
              Vouchering Of Documents
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Vouchering of Confidential Document"
                  value="pending"
                />
              )}
            </RouterLink>

            <RouterLink
              className="FstoSidebarLink-root"
              to="/confidential/voucher/returned-vouchers"
            >
              Returned/Held Vouchers
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Vouchering of Confidential Document"
                  value="return"
                />
              )}
            </RouterLink>
          </Box>
        )}

        {user.permissions.includes(13) && (
          <Box marginBottom={1}>
            <Typography variant="sidebar" marginLeft="10px" fontWeight={500} fontSize="12px">
              Transmittal
            </Typography>

            <RouterLink className="FstoSidebarLink-root" to="/confidential/transmitting">
              Transmittal of Documents
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Transmittal of Confidential Document"
                  value="pending"
                />
              )}
            </RouterLink>
          </Box>
        )}

        {user.permissions.includes(16) && (
          <Box marginBottom={1}>
            <Typography variant="sidebar" marginLeft="10px" fontWeight={500} fontSize="12px">
              Releasing
            </Typography>

            <RouterLink className="FstoSidebarLink-root" to="/confidential/releasing">
              Releasing of Cheque
              {!isChequeLoading && (
                <DisplayBubbleNotification
                  notificationArray={cheque}
                  permission="Releasing of Confidential Cheque"
                  value="pending"
                />
              )}
            </RouterLink>
          </Box>
        )}

        {user.permissions.includes(14) && (
          <Box marginBottom={1}>
            <Typography variant="sidebar" marginLeft="10px" fontWeight={500} fontSize="12px">
              Filing
            </Typography>

            <RouterLink className="FstoSidebarLink-root" to="/confidential/filing">
              Filing of Voucher
              {!isTransactionsLoading && (
                <DisplayBubbleNotification
                  notificationArray={transactions}
                  permission="Filing of Confidential Voucher"
                  value="pending"
                />
              )}
            </RouterLink>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarConfidentialDropdown;
